module.exports = __webpack_public_path__ + "static/media/ottawa.cde07a31.png";